import { render, staticRenderFns } from "./nodes.vue?vue&type=template&id=462f41f6&scoped=true"
import script from "./nodes.vue?vue&type=script&lang=js"
export * from "./nodes.vue?vue&type=script&lang=js"
import style0 from "./nodes.vue?vue&type=style&index=0&id=462f41f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e639414b8f28593ae71b2a471b1115a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f41f6",
  null
  
)

export default component.exports